import React from 'react';
import './ReduxFormStyles.scss';
import { Row, Col } from 'react-bootstrap';

const CheckboxGroupLabelLeft = ({
  input,
  label,
  labelSize,
  fieldSize,
  options,
  noFormGroup,
  meta: { touched, error },
}) => {
  let labelClass = 'control-label',
    wrapperClass = 'radio-group-left';
  if (labelSize) {
    labelClass += ' col-xs-' + labelSize;
    wrapperClass += ' col-xs-' + (12 - labelSize);

    if (fieldSize) {
      wrapperClass += ' col-md-' + fieldSize;
    }
  }

  const formGroupClass = noFormGroup ? 'form-group' : '';
  return (
    <div className={touched && error ? `${formGroupClass} has-error` : formGroupClass}>
      {label && <label className={labelClass}>{label}</label>}

      <div className={wrapperClass}>
        {options.map((option) => {
          return (
            <Row>
              <Col sm={8}>
                <div
                  className="radio-label-left"
                  onClick={() => input.onChange(!input.value)}
                >
                  {option.label}
                </div>
              </Col>
              <Col sm={4}>
                <div className={'form-radio-left'}>
                  <input
                    {...input}
                    type="checkbox"
                    id={input.name + option.value}
                    checked={input.value === option.value}
                  />
                  <label htmlFor={input.name + option.value} />
                </div>
              </Col>
            </Row>
          );
        })}
      </div>
      {touched && error && <span className="input-error">{error}</span>}
    </div>
  );
};

export default CheckboxGroupLabelLeft;
